import React from 'react';
import { Route, Routes } from 'react-router-dom';
import PlantReportsDashboard from "./PlantReportsDashboard";
import Log from "./Log";
import Reports from "./Reports";
import Manage from "./Manage";

const PlantReportsRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<PlantReportsDashboard />} />
      <Route path="/log" element={<Log />} />
      <Route path="/reports" element={<Reports />} />
      <Route path="/manage" element={<Manage />} />
    </Routes>
  );
}

export default PlantReportsRoutes;
